import { DownOutlined } from '@ant-design/icons';

export const getOption = (value: string, lang: string, customStyle?: string) => {
   switch (value) {
      case 'co':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='co'>
                        🇨🇴
                     </span>
                     {lang === 'es' ? 'Colombia' : 'Colombia'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'en':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p style={{}}>
                     <span role='img' aria-label='eu'>
                        🇺🇸
                     </span>
                     {lang === 'es' ? 'Estados Unidos' : 'United States'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'es-ES':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p style={{}}>
                     <span role='img' aria-label='es-ES'>
                        🇪🇸
                     </span>
                     {lang === 'es' ? 'España' : 'Spain'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'br':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='br'>
                        🇧🇷
                     </span>
                     {lang === 'es' ? 'Brasil' : 'Brazil'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'ar':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='ar'>
                        🇦🇷
                     </span>
                     {lang === 'es' ? 'Argentina' : 'Argentina'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'pa':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='pa'>
                        🇵🇦
                     </span>
                     {lang === 'es' ? 'Panamá' : 'Panama'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'cl':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='cl'>
                        🇨🇱
                     </span>
                     {lang === 'es' ? 'Chile' : 'Chile'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'pr':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='pr'>
                        🇵🇷
                     </span>
                     {lang === 'es' ? 'Puerto Rico' : 'Puerto Rico'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'pe':
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='pe'>
                        🇵🇪
                     </span>
                     {lang === 'es' ? 'Perú' : 'Peru'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
      case 'es':
      default:
         return (
            <div
               style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
               }}>
               <div className={customStyle || ''}>
                  <p>
                     <span role='img' aria-label='mx'>
                        🇲🇽
                     </span>
                     {lang === 'es' ? 'México' : 'Mexico'}
                  </p>
               </div>
               <div>
                  <DownOutlined style={{ color: '#D5D5D5' }} />
               </div>
            </div>
         );
   }
};
